import React, { useState } from 'react'

// import { theme } from '@hhgtech/hhg-components'
// import { Step } from 'components/atoms/step'
// import { Text } from 'components/atoms/text'
import { SharePopup } from 'components/organisms/sharePopup'
import { domainLocales } from 'domainLocales'
import { useRouter } from 'next/router'
// import FontIcon from 'public/icons/fontSize_line.svg'
import { useIntl } from 'react-intl'
import { genPropTrack, TRACK_GA } from 'utils/tracking'

import {
  StyledArticleBottomBar,
  // StyledProgress,
  StyledIconWrapper,
  StyledLikeWrapper,
  // StyledFontSetting,
  // StyledPopup,
  // StyledIconText,
} from './index.styled'

export type User = {
  avatar?: string
  profile: string
  name: string
}

export type Props = {
  articleUrl: string
  size?: 'lg' | 'md' | 'sm'
  className?: string
  liked?: boolean
  disliked?: boolean
  bookmarked?: boolean
  progress?: number
  commentCount?: number
  onCommentClick: () => void
  onLikeClick?: () => unknown
  onDislikeClick?: () => unknown
  onBookmarkClick?: () => unknown
  onFontClick?: () => unknown
  isMobile?: boolean
  ampLogo?: string
  currentFontSize: string
  onFontSelect: (fontSize: string) => void
}

const ArticleBottomBar = ({
  className,
  size = 'md',
  liked,
  disliked,
  bookmarked,
  // progress = 0,
  articleUrl,
  isMobile,
  commentCount = 0,
  onLikeClick,
  onDislikeClick,
  onBookmarkClick,
  onCommentClick,
}: // currentFontSize,
// onFontSelect,
Props) => {
  const { formatMessage: f } = useIntl()
  const [showSharePopup, setShowSharePopup] = useState(false)
  // const [showFontPopup, setShowFontPopup] = useState(false)

  const disableLikeDislike = disliked || liked

  const router = useRouter()
  const { locale, asPath } = router
  const sL = locale || 'vi-VN' // standardized locale

  // const fontSteps = [
  //   {
  //     value: 'small',
  //     topItem: (
  //       <img loading="lazy"
  //         src="/icons/fontSize-2_line.svg"
  //         alt="small"
  //         style={{
  //           width: 16,
  //         }}
  //       />
  //     ),
  //     bottomItem: (
  //       <Text type="bodytext-3" color={theme.mbColors.midGray}>
  //         Small
  //       </Text>
  //     ),
  //   },
  //   {
  //     value: 'medium',
  //     topItem: (
  //       <img loading="lazy"
  //         src="/icons/fontSize-2_line.svg"
  //         alt="medium"
  //         style={{
  //           width: 24,
  //         }}
  //       />
  //     ),
  //     bottomItem: (
  //       <Text type="bodytext-3" color={theme.mbColors.midGray}>
  //         Medium
  //       </Text>
  //     ),
  //   },
  //   {
  //     value: 'large',
  //     topItem: (
  //       <img loading="lazy"
  //         src="/icons/fontSize-2_line.svg"
  //         alt="large"
  //         style={{
  //           width: 32,
  //         }}
  //       />
  //     ),
  //     bottomItem: (
  //       <Text type="bodytext-3" color={theme.mbColors.midGray}>
  //         Large
  //       </Text>
  //     ),
  //   },
  // ]

  // const handleShowPopup = (
  //   value: boolean,
  //   e: React.MouseEvent<HTMLDivElement, MouseEvent>,
  // ) => {
  //   e.stopPropagation()
  //   setShowFontPopup(value)
  // }

  return (
    <StyledArticleBottomBar data-size={size} className={className}>
      {/* <StyledProgress
        style={{
          width: progress * 100 + '%',
        }}
      /> */}

      <>
        <StyledLikeWrapper
          data-disabled={disableLikeDislike}
          onClick={disableLikeDislike ? undefined : onLikeClick}
          data-is-liked={liked || undefined}
        >
          <div
            className="non-pointer-event-child"
            data-event-category={TRACK_GA.FEEDBACK.category}
            data-event-action="Yes"
            data-event-label={`https://${domainLocales[sL]}${asPath}`}
          >
            <img
              loading="lazy"
              data-event-category={TRACK_GA.FEEDBACK.category}
              data-event-action="Yes"
              data-event-label={`https://${domainLocales[sL]}${asPath}`}
              src={
                liked ? '/icons/thumbsup_solid.svg' : '/icons/thumbsup_line.svg'
              }
              alt=""
            />
          </div>
        </StyledLikeWrapper>
        <StyledLikeWrapper
          data-disabled={disableLikeDislike}
          onClick={disableLikeDislike ? undefined : onDislikeClick}
          data-is-disliked={disliked || undefined}
        >
          <div
            className="non-pointer-event-child"
            data-event-category={TRACK_GA.FEEDBACK.category}
            data-event-action="No"
            data-event-label={`https://${domainLocales[sL]}${asPath}`}
          >
            <img
              loading="lazy"
              data-event-category={TRACK_GA.FEEDBACK.category}
              data-event-action="No"
              data-event-label={`https://${domainLocales[sL]}${asPath}`}
              src={
                disliked
                  ? '/icons/thumbsdown_solid.svg'
                  : '/icons/thumbsdown_line.svg'
              }
              alt=""
            />
          </div>
        </StyledLikeWrapper>
        <StyledIconWrapper
          onClick={() => {
            if (isMobile && navigator.share) {
              navigator
                .share({
                  title: f({
                    id: 'authorPage.share.share',
                  }),
                  url: articleUrl,
                })
                // .then(() => {})
                .catch(console.error)
            } else {
              setShowSharePopup(true)
            }
          }}
          tabIndex={1}
        >
          <div
            data-event-category={TRACK_GA.SHARE.category}
            data-event-action="Click"
            data-event-label={`https://${domainLocales[sL]}${asPath}`}
          >
            <img loading="lazy" src="/icons/share_line.svg" alt="" />
          </div>
        </StyledIconWrapper>

        <SharePopup
          show={showSharePopup}
          shareUrl={articleUrl}
          onHidden={() => setShowSharePopup(false)}
        />

        <div>
          <StyledIconWrapper
            onClick={onBookmarkClick}
            tabIndex={1}
            {...genPropTrack(
              TRACK_GA.BOOK_MARK,
              `https://${domainLocales[sL]}${asPath}`,
            )}
          >
            <img
              loading="lazy"
              src={
                bookmarked
                  ? '/icons/bookmark_solid.svg'
                  : '/icons/bookmark_line_dark.svg'
              }
              alt=""
            />
          </StyledIconWrapper>
        </div>
      </>

      {/* <StyledFontSetting
        role="button"
        tabIndex={1}
        {...genPropTrack(
          TRACK_GA.CHANGE_ICON,
          `https://${domainLocales[sL]}${asPath}`,
        )}
        onClick={(e) => handleShowPopup(true, e)}
      >
        <FontIcon overflow="visible" height="24px" />
        {showFontPopup && !isMobile && (
          <div className="desktop-font-popup">
            <div
              className="background"
              onClick={(e) => handleShowPopup(false, e)}
            />
            <div className="content">
              <Step
                value={currentFontSize}
                steps={fontSteps}
                onSelect={(v, e) => {
                  e?.stopPropagation()
                  onFontSelect(v as string)
                }}
              />
            </div>
          </div>
        )}
        {isMobile && (
          <StyledPopup
            isOpen={showFontPopup}
            type="due-date"
            onClose={() => setShowFontPopup(false)}
            closeIcon={<img loading="lazy" src="/images/close.svg" alt="" />}
            id="font-setting-popup"
          >
            <div className="header">
              <Text type="subtitle-1">
                {f({ id: 'article.changeFontSize' })}
              </Text>
            </div>
            <div className="font-setting__wrapper">
              <Step
                value={currentFontSize}
                steps={fontSteps}
                onSelect={(v) => onFontSelect(v as string)}
              />
            </div>
          </StyledPopup>
        )}
      </StyledFontSetting> */}
      <StyledIconWrapper onClick={onCommentClick} tabIndex={1}>
        <div
          data-event-category={TRACK_GA.SHARE.category}
          data-event-action=""
          data-event-label={`https://${domainLocales[sL]}${asPath}`}
        >
          <img loading="lazy" src="/icons/ask-doctor.svg" alt="" />
          {commentCount > 0 ? (
            <div className="comment-count">{commentCount}</div>
          ) : (
            <div className="empty-comment" />
          )}
        </div>
      </StyledIconWrapper>
    </StyledArticleBottomBar>
  )
}

export { ArticleBottomBar }
